import createDOMPurify from "dompurify";

import { splitStyleDeclarations } from "./splitStyleDeclarations";

const purify = createDOMPurify(globalThis);

const COLOR_PROPERTIES = new Set(["color", "-webkit-text-fill-color"]);

// Strip inline text color (e.g. style="color:#121317") that comes from the API,
// since it can make text unreadable.
// Other inline styling is left intact.
purify.addHook("uponSanitizeAttribute", (_node, data) => {
  if (data.attrName === "style") {
    const kept = splitStyleDeclarations(data.attrValue).filter((decl) => {
      const prop = decl.split(":")[0].trim().toLowerCase();
      return !COLOR_PROPERTIES.has(prop);
    });

    if (kept.length === 0) {
      data.keepAttr = false;
      return;
    }
    data.attrValue = kept.join("; ");
  }
});

export const sanitizeHtml = (html: string): string => purify.sanitize(html);
